import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface InventoryTransactionsState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allTransactionsList: any[];
}

const initialState: InventoryTransactionsState = {
  data: null,
  currentPage: null,
  totalRecords: null,
  totalPages: null,
  allTransactionsList: [],
};

export const inventoryTransactionsSlice = createSlice({
  name: "inventoryTransactions",
  initialState,
  reducers: {
    setInventoryTransactions: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setInventoryTransactionsBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setInventoryTransactionsList: (state, action) => {
      state.allTransactionsList = action.payload.data;
    },
    reset: () => initialState,
  },
});

export const {
  setInventoryTransactions,
  setInventoryTransactionsBySearch,
  setInventoryTransactionsList,
  reset,
} = inventoryTransactionsSlice.actions;

export const getInventoryTransactionsDetails = (state: RootState) =>
  state.inventoryTransactions.data;
export const getInventoryTransactionsTotalRecords = (state: RootState) =>
  state.inventoryTransactions.totalRecords;
export const getInventoryTransactionsSearch = (state: RootState) =>
  state.inventoryTransactions.data;
export const getInventoryTransactionsList = (state: RootState) =>
  state.inventoryTransactions.allTransactionsList;

export default inventoryTransactionsSlice.reducer;
